import { gql } from "@apollo/client";

export const MUTATION_START_TRANSACTION = gql`
  mutation StartTransaction($input: CreateTransactionInput!) {
    createTransaction(input: $input) {
      ... on Transaction {
        id
        transactionRef
        amountInCents
        paymentsTotalInCents
        paymentsSurchargeTotalInCents
        transactionType
        status
        state
        deviceId
        deviceDescription
        startedAt
        source
        completedAt
        cancelledAt
        userDescription
        userId
        payments {
          id
          method
          amount
          transactionRef
          surchargeAmount
          totalAmount
          state
          errorMessage
          metadata
          receipt
          createdAt
          updatedAt
          deletedAt
        }
        createdAt
        updatedAt
        deletedAt
      }
      ... on TransactionRefAlreadyExistsError {
        errorCode
        message
      }
      ... on InvalidTransactionRefError {
        errorCode
        message
      }
      ... on DeviceDisabledError {
        errorCode
        message
      }
    }
  }
`;

export const QUERY_POLL_OUTCOME = gql`
  query PollOutcome($id: ID!) {
    transaction(id: $id) {
      id
      transactionRef
      amountInCents
      paymentsTotalInCents
      transactionType
      status
      state
      deviceId
      deviceDescription
      paymentsSurchargeTotalInCents
      startedAt
      source
      completedAt
      cancelledAt
      userDescription
      userId
      payments {
        id
        method
        amount
        transactionRef
        surchargeAmount
        totalAmount
        state
        errorMessage
        metadata
        receipt
        createdAt
        updatedAt
        deletedAt
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
